import React, { useState } from "react"
import contactGif from "../img/Get in touch-amico.svg"
import swal from "sweetalert"
import firebase from "../firebase"
import { ValidateEmail, notEmpty, allLetter } from "../functions"

const Contact = () => {
  const [contact, setContact] = useState({
    name: "",
    email: "",
    message: ""
  })

  const handleContact = (e) => {
    const { name, value } = e.target
    setContact((prev) => {
      return {
        ...prev,
        [name]: value
      }
    })
  }

  const submitContact = (e) => {
    e.preventDefault()
    if (
      allLetter(contact.name, "Name") &&
      ValidateEmail(contact.email) &&
      notEmpty(contact.message)
    ) {
      const contactRef = firebase.database().ref("Contact")
      contactRef.push(contact, function (error) {
        if (error) {
          swal({
            title: "Warning",
            text: "Something went wrong Please Try Again",
            icon: "warning"
          })
        } else {
          setContact({
            name: "",
            email: "",
            message: ""
          })
          swal({
            title: "success",
            text: "Successfully Sent.",
            icon: "success"
          })
        }
      })
    }
  }

  return (
    <section id="contact">
      <div className="container pb-5">
        <div className="row py-4">
          <div className="col-12 pb-5 text-center">
            <h1 className="sectionname">Contact Me</h1>
            <hr className="mx-auto" />
          </div>
          <div className="col-md-6 pr-4" data-aos="fade-up">
            <img src={contactGif} alt="contact" className="contact__gif" />
          </div>
          <div className="col-md-6 pt-md-0 pt-lg-3" data-aos="fade-up">
            <h2 className="getin_touch text-center">Get in touch</h2>
            <form>
              <div className="form-group">
                <label>Name</label>
                <input
                  value={contact.name}
                  onChange={handleContact}
                  className="form-control"
                  name="name"
                  placeholder="Enter Your Name"
                />
              </div>
              <div className="form-group">
                <label>Email address</label>
                <input
                  value={contact.email}
                  onChange={handleContact}
                  type="email"
                  name="email"
                  className="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Enter Your Email"
                />
                <small id="emailHelp" className="form-text text-muted">
                  I'll never share your email with anyone else.
                </small>
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea
                  name="message"
                  value={contact.message}
                  onChange={handleContact}
                  className="form-control"
                  rows="3"></textarea>
              </div>
              <button
                type="submit"
                onClick={submitContact}
                className="btn btn-outline-primary">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact
